var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuButtonCw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 34,
    viewBox: "0 0 68 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 34,
    rx: 10,
    fill: "#C88F1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.52 22.4443H16.368V18.1183C16.368 17.1383 16.214 15.6963 16.102 14.7163H16.158L16.998 17.1523L18.594 21.5203H19.784L21.38 17.1523L22.234 14.7163H22.304C22.192 15.6963 22.024 17.1383 22.024 18.1183V22.4443H23.914V12.0843H21.618L19.896 16.9423C19.686 17.5863 19.504 18.2583 19.266 18.9303H19.21C18.986 18.2583 18.804 17.5863 18.566 16.9423L16.802 12.0843H14.52V22.4443ZM26.4555 22.4443H32.9655V20.7083H28.5275V17.9503H32.1535V16.2003H28.5275V13.8063H32.8115V12.0843H26.4555V22.4443ZM35.0688 22.4443H37.0288V18.3003C37.0288 17.0963 36.8608 15.7943 36.7628 14.6883H36.8328L37.8828 16.9003L40.8788 22.4443H42.9928V12.0843H41.0188V16.2143C41.0188 17.3903 41.1868 18.7763 41.2988 19.8543H41.2288L40.1788 17.6143L37.1688 12.0843H35.0688V22.4443ZM49.5311 22.6403C52.0651 22.6403 53.5351 21.2263 53.5351 17.7963V12.0843H51.5471V17.9783C51.5471 20.1203 50.7491 20.8483 49.5311 20.8483C48.3131 20.8483 47.5571 20.1203 47.5571 17.9783V12.0843H45.4991V17.7963C45.4991 21.2263 46.9971 22.6403 49.5311 22.6403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButtonCw);
export default __webpack_public_path__ + "static/media/menu-button_cw.a11465c1def08774b38fb0c97c62edba.svg";
export { ForwardRef as ReactComponent };